import React from "react";
import CustomText from "@/components/ui/text/custom-text";
import useDynamicTranslation from "@/hooks/use-universal-transalation";
import cn from "@/hooks/class-names";
import { DownloadIcon } from "lucide-react";
import PdfViewer from "./pdf-render/pdf-viewer";
import { Button } from "rizzui";
import { downloadPDF } from "@/utils/pdfDownload";

export default function ResourceItem({ ele, className, btnText }) {
  const { getTranslated } = useDynamicTranslation([
    "resources",
    "right-to-information",
  ]);
  const handleDownload = (url) => {
    if (!url) {
      console.error("Invalid URL:", url);
      return;
    }
    try {
      const filename = url.split("/").pop() || "download.pdf";
      downloadPDF(url, filename).catch((error) => {
        console.error("Download failed:", error);
      });
    } catch (error) {
      console.error("Error extracting filename:", error);
    }
  };
  return (
    <div className="min-h-[400px] max-h-[350px] flex flex-col gap-4">
      {/* PDF Viewer Section */}
      <div
        className={cn("h-[66%] relative flex-grow", ele?.className, className)}
      >
        {ele?.url ? (
          <PdfViewer url={ele.url} />
        ) : (
          <p className="text-gray-500">No PDF available</p>
        )}
      </div>
      {/* Title Section */}
      <div className="px-4 text-left text-sm">
        <CustomText text={ele?.title || ele?.languageKey || "Untitled"} />
      </div>

      {/* Button Section - Stays at Bottom */}
      <div className="px-4 pb-3 mt-auto">
        <Button
          className="bg-orange text-white w-full capitalize font-bold tracking-wider space-x-2"
          size="md"
          onClick={() => handleDownload(ele?.url)}
          disabled={!ele?.url}
        >
          <DownloadIcon className="h-5 w-5" />
          <span>{getTranslated(btnText || "Preview")}</span>
        </Button>
      </div>
    </div>
  );
}
